import { useQuery } from '@tanstack/react-query';
import type { ApiListParams } from '@dc-trans/data-layer';
import { getNotifications } from '@dc-trans/data-layer';

export const useNotifications = (params: ApiListParams<any>) => {
  return useQuery({
    queryKey: ['notifications', params],
    queryFn: () => getNotifications(params),
    refetchInterval: 30000,
  });
};
